<template>

  <div class="row" ref="mediaPartnerForm">

    <div class="col-xs-12 col-md-12 col-sm-12">
      <ValidationObserver v-slot="{ handleSubmit }" ref="formValidator">
        <div class="col-12">
          <div class="card card-wizard" id="wizardCard">
            <form-wizard shape="tab"
                         :title="formTitle"
                         :subtitle="''"
                         error-color="#FB404B"
                         color="#35495E"
                         ref="itemWizard">
              <tab-content title="English Content"
                           class="col-12"
                           icon="nc-icon nc-chart-pie-35"
                           :before-change="() => validateStep('englishStep')">
                <english-step :formData="formData ? formData['en'] : defaultFormData['en']"
                              :editMode="editMode"
                              ref="englishStep"
                              :builderData="builderData"
                              @on-validated="onStepValidated" @submit-step="submitStep"></english-step>
              </tab-content>
              <tab-content v-for="(lang, index) in languageList" :key="index" :title="lang.label+' Content'"
                           class="col-12"
                           icon="nc-icon nc-chart-pie-35"
                           :before-change="() => validateStep(lang.value)">
                <other-languages-step
                  :formData="formData ? formData[lang.value] : defaultFormData[lang.value]"
                  :editMode="editMode"
                  :isSubmit="languageList.length - 1 === index"
                  :lang="lang" :ref="lang.value" @on-validated="onStepValidated"
                  @submit-step="submitStep"></other-languages-step>
              </tab-content>

              <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Back</button>
              <button slot="next" class="btn btn-default btn-fill btn-wd btn-next">Next</button>
              <button slot="finish" class="btn btn-success btn-fill btn-wd" :disabled="entityNotFoundError || submitting">Finish</button>
            </form-wizard>
          </div>
        </div>
      </ValidationObserver>

    </div>

  </div>
</template>
<script>
import {extend} from "vee-validate";
import {mapGetters} from "vuex";
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import EnglishStep from "./Wizard/EnglishStep";
import OtherLanguagesStep from "./Wizard/OtherLanguagesStep";


extend("required", {
  message: "{_field_} is required"
});

export default {

  components: {
    FormWizard,
    TabContent,
    OtherLanguagesStep,
    EnglishStep,
  },

  data() {
    return {
      editMode: false,
      loader: {},
      id: undefined,

      formTitle: "",
      entityNotFoundError: false,
      submitting: false,
      formData: {},
      defaultFormData: {
        name: "",
        content: "",
        image: "",
        is_active: "",
      },
      wizardModel: {},
      builderData: {
        forumList: [],
      },


    };
  },

  computed: {
    ...mapGetters({
      languageList: "global/languageList"
    })
  },
  mounted() {
    this.loader = this.$loading.show({
      container: this.$refs.mediaPartnerForm
    });
    this.setNullFormData();
    let data = {};
    this.axios.post("media-partners/builder", data).then((response) => {
      this.builderData.forumList = response.data.forums;
      this.id = this.$route.params['id'];
      if (this.id !== undefined) {
        this.editMode = true;
        this.formTitle = "Edit Media Partner";
        this.getMediaPartner();
      } else {
        this.editMode = false;
        this.formTitle = "Add Media Partner";
        this.loader.hide();
      }

    }).catch((error) => {
      console.error(error);
    })
  },


  methods: {
    getMediaPartner() {
      let data = {
        'id': this.id,
      };
      this.axios.post("media-partners/get", data).then((response) => {
        this.formData = response.data;
        this.formData['en'].forums = response.data['en'].backForums.map(forum => forum.id);
        this.loader.hide();
      }).catch((error) => {
        if (error.response.status === 404) {
          this.entityNotFoundError = true;
          this.$notify({
            message: "Media Partner Not Found",
            timeout: 2000,
            type: 'danger'
          });
          this.loader.hide();
        } else {
          console.error(error);
        }
      })
    },
    submit() {
      let request;
      let successMessage;
      this.submitting = true;
      if (this.editMode === true) {
        request = this.axios.put("media-partners/update/" + this.id, this.formData);
        successMessage = "Media Partner Updated Successfully";
      } else {
        request = this.axios.post("media-partners/create", this.formData);
        successMessage = "Media Partner Added Successfully";
      }

      request.then((response) => {
        this.$notify({
          message: successMessage,
          timeout: 1000,
          type: 'success'
        })
        this.$router.push("/media-partners/list");
      }).catch((error) => {
        if (error.response.status === 422) {
          this.$refs.formValidator.setErrors(error.response.data.errors);
          this.$refs.itemWizard.navigateToTab(0);
        } else {
          console.log(error.response)
        }
      }).finally(() => {
        this.submitting = false;
      })
    },
    validateStep(ref) {
      if (Array.isArray(this.$refs[ref])){
        return this.$refs[ref][0].validate();
      }else{
        return this.$refs[ref].validate();
      }
    },
    onStepValidated(validated, model) {
      this.wizardModel = {...this.wizardModel, ...model}
    },
    submitStep(data, lang, isSubmit){
      this.formData[lang] = data;
      if (isSubmit){
        this.submit();
      }
    },
    setNullFormData(){
      console.log(this.languageList)
      this.defaultFormData['en'] = {

      };
      this.languageList.forEach(lang => {
        this.defaultFormData[lang] = {

        }
      })
    },
  }
}
</script>
